import { ChatBotDialogOptions } from "@/models/chatbot.ts";

export const roleUser = "user";
export const roleLeadForm = "lead_form";
export const roleAssistant = "assistant";
export const msgActionVisitorData = "action_visitor_data";
export const msgActionReaction = "action_reaction";

export const msgActionStateSending = "sending";
export const msgActionStateSent = "sent";

export const tabHome = "home";
export const tabMessages = "messages";
export const tabContact = "contact";

export interface ChatBotProps {
  token: string;
  design: ChatBotDialogOptions;
  onClose: () => void;
  onRefresh: () => void;
  onExpand: () => void;
  showExpandBtn: boolean;
  hideCloseBtn: boolean;
  messages: null | Msg[];
}

export type Msg = {
  id: number;
  historyId?: string;
  streaming?: boolean;
  text: string;
  role: string;
  name?: string;
  avatar?: string;
  buttons?: any[];
  sources?: any[];
  sourcesExpanded?: boolean;
  sourceID?: number; // index of current source we show
  formFields?: FormField[];
  actionState?: string; // "sending", "sent"
  time?: number;
  reaction?: string;
};

export type TForm = {
  fields?: FormField[];
  action: string;
  state?: string; // "sending", "sent"
};

export type ChatResponse = {
  mode: string;
  data: string;
  docs?: any[];
  buttons?: any[];
  sources?: Source[];
  message?: Msg;
};

interface FormField {
  title: string;
  value?: string;
}

export interface Source {
  title?: string;
  description?: string;
  url?: string;
  image?: string;
  favicon?: string;
}
